/*
**author: 许谦
**date: 2017-07-05
*/
import React from 'react';
import transLoader from '@beisen/i18n-translation-loader';

require('./ErrorPage.scss');
const defaultTranslation = {
    nothingTip: '这里什么都没有',
    noPermissionTip: '您暂时没有权限访问',
    noPageTip: '页面不存在',
    pageError: '页面错误',
    unableViewPage: '暂时无法访问该页面，您可以',
    refresh: '刷新',
    tryAgain: '试试'
  };

class ErrorPage extends React.Component {
    constructor(props) {
      super(props);
      this.translation = Object.assign({}, defaultTranslation, transLoader({
        nothingTip: 'pageNotice.nothingTip',
        noPermissionTip: 'pageNotice.noPermissionTip',
        noPageTip: 'pageNotice.noPageTip',
        pageError: 'pageNotice.pageError',
        unableViewPage: 'pageNotice.unableViewPage',
        refresh: 'pageNotice.refresh',
        tryAgain: 'pageNotice.tryAgain',
        backToLast: 'pageNotice.backToLast'
      }), props.translation);
      const { translation } = this;
      this.messageMap = {
        inner_401: translation.nothingTip,
        inner_404: props.message,
        outer_403: translation.noPermissionTip,
        outer_404: translation.noPageTip,
        outer_500: translation.pageError
      };
      this.errorImage = {
        inner_401: 'error-balloon',
        inner_404: 'error-box',
        outer_403: 'error-box',
        outer_404: 'error-404',
        outer_500: 'error-500'
      };
    }

    refresh() {
    	window.location.reload();
    }

    // 渲染错误提示图片
    renderImage(errorType) {
      return(
        <div className={`image ${this.errorImage[errorType]}`}></div>
      );
    }
    // http code 404、500 渲染刷新按钮
    renderRefresh(errorType) {
      const { translation } = this;
      if(errorType === 'outer_404' || errorType === 'outer_500') {
        return <div className="errorMessage2">{translation.unableViewPage}<a onTouchTap={this.refresh}>{translation.refresh}</a>{translation.tryAgain}</div>;
      }
    }

    renderContent() {
      return(
        <div className="content">
          {this.renderImage(this.props.errorType)}
          <div className="errorMessage">{this.messageMap[this.props.errorType]}</div>
          {this.renderRefresh(this.props.errorType)}
        </div>
      );
    }
    render() {
        return (
            <div className="errorPage-container" >
                {this.renderContent()}
            </div>
        );
    }
  }


ErrorPage.propTypes = {
  errorType: React.PropTypes.string.isRequired
};


export default ErrorPage;



// WEBPACK FOOTER //
// ./src/components/ErrorPage/ErrorPage.js